export default "dist/images/block-feature-overlap4.4c6ca44.png";